const words = {
  category: '类别',

  settings: '设置',
  settings_importExport: '数据导入和导出',
  settings_selectLanguage: '选择界面语言',
  settings_selectLanguage_title: '选择一种语言:',
  settings_showIcons: '在类别和链接中显示图标',
  settings_guide: "参加培训课程",
  settings_userAgreement: '用户协议（仅限俄语）',
  settings_about: '关于应用程序',
  settings_showDeleteButton: "刷卡时显示删除按钮",
  settings_swipeIcons: "刷卡时用图标代替文字",
  settings_dateBlock: '日期',
  settings_interfaceBlock: '介面',
  settings_informationBlock: '信息',

  importExport: '数据导入和导出',
  importExport_import: "进口",
  importExport_export: "出口",
  importExport_exportJSON: "将数据导出到一个.JSON文件",
  importExport_exportJSON_2: "将数据导出为一个字符串",
  importExport_importJSON: "从一个.JSON文件导入数据",
  importExport_importJSON_2: "从一个字符串中导入数据",
  importExport_importJSON_3: "从Linkbox导入数据",
  importExport_manual: '说明（仅限俄语）',

  about: '关于应用程序',
  about_subtitle: '您的链接将永远不会丢失，因为现在您可以将它们存储在一个方便的跨平台URList应用程序中！ 创建类别和存储主题链接在他们,方便打开他们在一个点击!',
  about_developer: '开发人员:',
  about_version: '应用程序版本:',
  about_4pda: '在4pda应用程序的主题',
  about_site: '项目官方网站',
  about_donate: '支持项目',
  about_telegram: "电报中的开发者频道",
  about_github: "GitHub上的源代码",

  universalPage_inputPlaceholder: '输入/复制所需数据',
  universalPage_info1: '与此窗口交互后，请务必重新启动应用程序以应用更改',
  universalPage_info2: '要应用更改，请单击底部的圆形按钮',

  newCategory: '新类别',
  newCategory_name: '类别名称',
  newCategory_desc: '类别描述',

  newLink: '新连结',
  newLink_name: '链接名称',
  newLink_url: '网址',
  newLink_errorTitle: '链接必须包含以下子字符串:',
  newLink_errorItem1: '子字符串"https://"或"http://"',
  newLink_errorItem2: '一分',

  editCategory: '编辑类别',
  editCategory_name: '类别名称',
  editCategory_desc: '类别描述',
  editCategory_delete_title: '你确定吗？',
  editCategory_delete_desc: '将不可能撤消删除的内容!',
  editCategory_delete_OK: '取消',
  editCategory_delete_DELETE: '删除',

  editLink: '链接编辑',
  editLink_name: '链接名称',
  editLink_url: '网址',
  editLink_errorTitle: '链接必须包含以下子字符串:',
  editLink_errorItem1: '子字符串"https://"或"http://"',
  editLink_errorItem2: '一分',

  sort: '排序方法',
  sort_lastСhange: '默认情况下（从上次更改开始）',
  sort_alphabetically1: '按字母顺序 (A-Z)',
  sort_alphabetically2: '按字母顺序 (Z-A)',

  categoryItem_edit: '编辑',
  categoryItem_favoriteAdd: '在收藏夹中',
  categoryItem_favoriteRemove: '从收藏夹中删除',

  universal_basicInformation: '基本信息',
  universal_customization: '定制化',
  universal_iconColor: '图标颜色',
  universal_clickToColorSelect: '按圆圈选择一种颜色',
  universal_iconType: '图标类型',
  universal_firstWord: "第一封信",
  universal_nothing: '没有什么',
  universal_favicon: '网站的Favicon',
  universal_onlyAndroid: "该功能仅适用于安卓设备",

  guide_dialog_title: "第一次来这里？",
  guide_dialog_desc: "你愿意接受界面管理方面的培训吗？(培训将在以后的设置中提供)",
  guide_dialog_OK: "开始培训",
  guide_dialog_NO: "关闭",

  guide: "培训",
  guide_slide1_title: "基本名单管理",
  guide_slide1_desc: "要改变列表，或添加到收藏夹，只需向左或向右滑动，打开一个类别或链接，只需点击它即可",
  guide_slide2_title: "一切为了您的方便",
  guide_slide2_desc: "随心所欲地改变图标，改变你的类别和链接上的颜色或图标（禁用可以在细微处进行）。",
  guide_slide3_title: "将您需要的一切添加到您的收藏夹中",
  guide_slide3_desc: "你不再需要在成堆的其他链接中寻找最重要的链接，现在有了收藏夹，就可以做到这一点。",
  guide_slide4_title: "这就是它的全部内容。",
  guide_slide4_desc: "你现在已经完全准备好使用URList了，请享受吧",
  guide_slide4_button: "近距离培训",

  export_complete: "文件保存导出成功，保存到路径：%PATH%。", // %PATH% - Instead of this value the path to the file will appear
  import_complete: "数据成功导入",
  exportError_dir: "错误：无法创建文件夹，检查应用程序的权限",
  exportError_file: "错误：无法创建文件，请检查应用程序的权限",
  importError_validation: "错误：导入的数据被破坏",
  import_linkBox_converting: "有一个将数据从Linkbox转换为URList配置的过程，请稍候。..",

  search: "搜索",

  tabbar_basicInformation: "基本信息",
  tabbar_customization: "外观",

  langName_custom: "选择不同的语言。JSON文件",

  customLanguage_wait: "等待文件选择",
  customLanguage_cheсking: "检查一下。..",
  customLanguage_prompt: "输入数据。json文件在下面的行",
  customLanguage_error: "文件选择错误",
};

export default words;
